const config = {
  apiGateway: {
    REGION: 'us-west-2',
    INTERNAL_API_URL: 'https://ozm3ig9zgl.execute-api.us-west-2.amazonaws.com/prod',
    TARGET_API_URL: 'https://jcgsl6wpq4.execute-api.us-west-2.amazonaws.com/api',
    TEAMS_APP_URL: 'https://teams.testing.platform.forwoodsafety.com/teams',
    QS_DASHBOARD_URL: '',
    CLIENT_TIMEZONE: 'America/Sao_Paulo'
  },
  reactApp: {
    VERSION: 'targets-1.11.0',
    HOSTNAME: 'https://targets.testing.platform.forwoodsafety.com'
  }
};

export default config;